"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var useRating_1 = __importDefault(require("./useRating"));
var components_1 = require("stremio/components");
var Ratings = function (_a) {
    var ratingInfo = _a.ratingInfo, className = _a.className;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, useRating_1.default)(ratingInfo), onLiked = _b.onLiked, onLoved = _b.onLoved, liked = _b.liked, loved = _b.loved;
    var disabled = (0, react_1.useMemo)(function () { return (ratingInfo === null || ratingInfo === void 0 ? void 0 : ratingInfo.type) !== 'Ready'; }, [ratingInfo]);
    var items = (0, react_1.useMemo)(function () { return [
        {
            icon: liked ? 'thumbs-up' : 'thumbs-up-outline',
            label: liked ? t('RATING_UNLIKE') : t('RATING_LIKE'),
            disabled: disabled,
            onClick: onLiked,
        },
        {
            icon: loved ? 'heart' : 'heart-outline',
            label: loved ? t('RATING_UNLOVE') : t('RATING_LOVE'),
            disabled: disabled,
            onClick: onLoved,
        },
    ]; }, [liked, loved, disabled]);
    return (react_1.default.createElement(components_1.ActionsGroup, { items: items, className: className }));
};
exports.default = Ratings;
